import { render, staticRenderFns } from "./Eway.vue?vue&type=template&id=32d6b65a&scoped=true&"
import script from "./Eway.vue?vue&type=script&lang=ts&"
export * from "./Eway.vue?vue&type=script&lang=ts&"
import style0 from "./Eway.vue?vue&type=style&index=0&id=32d6b65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d6b65a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VImg,VLayout})
